import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { of } from 'rxjs';
import { filter, catchError, tap, map, switchMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// declare var google: any;

@Injectable()
export class GeocodeService {
    private geocoder: any;

    constructor(private httpClient: HttpClient, @Inject('apiEndPoint') private apiEndPoint: string,) { 
    this.geocoder = google? new google.maps.Geocoder():null;

    }

    geocodeAddress(location: string): Observable<any> {
                return new Observable(observer => {
                    this.geocoder?.geocode({ 'address': location }, (results, status) => {
                        if (status == google.maps.GeocoderStatus.OK) {
                            observer.next({
                                lat: results[0].geometry.location.lat(),
                                lng: results[0].geometry.location.lng()
                            });
                        } else {
                            console.log('Error - ', results, ' & Status - ', status);
                            observer.next({});
                        }
                        observer.complete();
                    });
                })
            // })
        // )
    }
    geocodeFromLatlng(location: string): Observable<any> {
        console.log(location)
        return new Observable(observer => {
            this.geocoder.geocode({ 'location': location }, (results, status) => {
                console.log(results, status);
                if (status == google.maps.GeocoderStatus.OK) {
                    observer.next(results[0].formatted_address);
                } else {
                    console.log('Error - ', results, ' & Status - ', status);
                     observer.next('');
                }
                observer.complete();
            });
        })
    // })
// )
}

getDeviceStatus(id) {
    let headers = new HttpHeaders();
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/edgedevicemaster_slice/' + id, { headers });
  }

}
